<template>
  <div class="summary-row">
    <div class="summary-text font-topic" :style="'width:' + tableColWidth['selection'] + 'px'">
      统计
    </div>
    <div class="summary-fixed">
      <summary-cell
        v-for="field in fixedFields"
        :key="field.cid"
        :field="field"
        :col-width="tableColWidth[field.value]"
        :value="gatherResult[field.cid]"
        :gather-type="gatherSetting[field.cid]"
        @change="changeSetting"
      ></summary-cell>
    </div>
    <div ref="summaryWrapper" class="summary">
      <summary-cell
        v-for="field in normalFields"
        :key="field.cid"
        :field="field"
        :col-width="tableColWidth[field.value]"
        :value="gatherResult[field.cid]"
        :gather-type="gatherSetting[field.cid]"
        @change="changeSetting"
      ></summary-cell>
    </div>
  </div>
</template>

<script>
import SummaryCell from "./Cell"
import { getReports } from "@/api/sheet/sheetView"
import { getFrontSetting, setFrontSetting } from "@/api/user"

export default {
  name: "summary-row",
  components: { SummaryCell },
  props: {
    viewId: String,
    conditions: Array,
    fields: {
      type: Array,
      default: () => []
    },
    tableColWidth: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      gatherSetting: {},
      gatherResult: {}
    }
  },
  computed: {
    fixedFields() {
      return this.fields.filter(i => i.fixed) || []
    },
    normalFields() {
      return this.fields.filter(i => !i.fixed) || []
    }
  },
  mounted() {
    getFrontSetting(`${this.viewId}_gather`).then(gatherSetting => {
      this.gatherSetting = gatherSetting || {}
      this.refreshReports()
    })
  },
  methods: {
    refreshReports() {
      getReports({
        viewId: this.viewId,
        conditions: this.conditions,
        gatherSetting: this.gatherSetting
      }).then(res => (this.gatherResult = res))
    },
    changeSetting({ cid, gatherType }) {
      setFrontSetting(gatherType, `${this.viewId}_gather`, cid).then(() => {
        this.gatherSetting[cid] = gatherType
        this.refreshReports()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$summery-height: 42px;
.summary-row {
  background: $color-bg-select;
  height: $summery-height;
  display: flex;
  text-align: center;
  align-items: center;
  .summary-text {
    width: 50px;
    flex-shrink: 0;
    color: $color-font-first;
    font-size: $font-size-main;
  }
  .summary-fixed,
  .summary {
    display: flex;
    .grid {
      flex-shrink: 0;
      height: $summery-height;
      line-height: $summery-height;
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      ::v-deep .dropdown-menu {
        display: flex;
        justify-content: center;
        align-items: center;
        .text-wrap {
          width: 100%;
          .el-icon-arrow-down {
            display: none;
          }
        }
      }
      &:hover {
        background-color: #d1d1d1;
        ::v-deep {
          .font-main,
          .el-icon-arrow-down {
            color: $color-font-title;
            display: inline !important;
          }
        }
      }
    }
  }
  .summary {
    overflow: hidden;
    padding-right: 200px; // 表格最右边有一列“操作列”，留出空白
  }
}
</style>
